export default __webpack_public_path__ + "static/media/new-book-preview.8abc9b26.png";